export const CREATE_TDS_SECTION  = 'CREATE_TDS_SECTION';
export const GET_TDS_SECTION  = 'GET_TDS_SECTION';
export const TDS_SECTION_REQUEST  = 'TDS_SECTION_REQUEST';
export const DELETE_TDS_SECTION  = 'DELETE_TDS_SECTION';
export const UPDATE_TDS_SECTION  = 'UPDATE_TDS_SECTION';
export const TDS_SECTION_REQUEST_FAILURE  = 'TDS_SECTION_REQUEST_FAILURE';